import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActivityPanel',
    props: {
        title: null,
        goToAllTitle: null,
        href: null
    },
    emits: ["goToAll"],
    setup(__props, { emit }) {
        const props = __props;
        return { __sfc: true, props, emit };
    }
});
